<template>
  <v-card flat class="outline">
    <v-card-title v-if="translatedLabel">
      <span class="subtitle-1">{{ translatedLabel }}</span>
    </v-card-title>
    <v-card-text v-if="translatedDescription" :class="descriptionClass">
      {{ translatedDescription }}
    </v-card-text>
    <!-- Images -->
    <v-container fluid grid-list-xs class="pt-0 px-3">
      <v-layout row wrap>
        <v-flex v-for="id in items" :key="id" class="xs12 sm6 md4 lg3 xl2">
          <v-img contain
            v-if="images[id]"
            :src="images[id]['medium']"
            @click="showDialogImage(id)"
            height="200"
            class="outline"
          />
        </v-flex>
      </v-layout>
    </v-container>
    <!-- Dialog viever -->
    <v-dialog v-model="dialog">
      <v-card>
        <v-img
          v-if="images[dialogImage]"
          :src="images[dialogImage]['orig']"
          @click="hideDialogImage()"
          class="pointer"
        />
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style scoped>
  .v-image:hover {
    cursor: pointer;
  }
  .outline {
    border: 1px solid #eee;
    border-radius: 2px;
  }
</style>

<script>
import translationMixin from './checklist-translation-mixin.es6'

export default {
  name: 'checklist-image',
  props: {
    level: Number,
    index: Number,
    label: String,
    description: String,
    items: Array
  },
  mixins: [translationMixin],
  data () {
    return {
      dialog: false,
      dialogImage: null
    }
  },
  computed: {
    descriptionClass () {
      return {
        'pt-0': !!this.translatedLabel,
        'grey--text': true,
        'text--darken-2': true
      }
    },
    images () {
      return this.$store.state.files
    }
  },
  methods: {
    hideDialogImage (id) {
      this.dialogImage = null
      this.dialog = false
    },
    async showDialogImage (id) {
      await this.getImageSource(id, '') // orig
      this.dialogImage = id
      this.dialog = true
    },
    async loadImages () {
      try {
        await Promise.all(this.items.map((id) => {
          return this.getImageSource(id)
        }))
      } catch (error) {
        console.error(error)
      }
    },
    async getImageSource (imageId, size = 'medium') {
      try {
        return this.$store.dispatch('checklist/fetchImage', {
          id: imageId,
          requiredSize: size
        })
      } catch (error) {
        return Promise.reject(error)
      }
    }
  },
  created () {
    if (this.items.length) {
      this.loadImages()
    }
  }
}
</script>
